export const TOOLTIP = 'tooltip';
